var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component } from 'angular-ts-decorators';
import { resetLoadingBtns, setLoadingBtn } from '../shared/util/loading-button-util';
let ConnectEmailInboxController = class ConnectEmailInboxController {
    $http;
    $location;
    error = false;
    tokenResent = false;
    pageState = {
        error: 'ERROR',
        tokenExpired: 'TOKEN_EXPIRED',
        tokenInvalid: 'TOKEN_INVALID',
        tokenResent: 'TOKEN_RESENT',
        connectIMAP: 'CONNECT_IMAP',
        connectOffice: 'CONNECT_OFFICE',
        connectIndividual: 'CONNECT_INDIVIDUAL',
    };
    // Minification-safe CI injections, everything @Inject()ed somewhere must be mentioned here:
    static $inject = ['$http', '$location'];
    constructor($http, $location) {
        this.$http = $http;
        this.$location = $location;
        const queryParams = $location.search();
        if (queryParams.success === 'false') {
            this.error = true;
        }
    }
    getPageState(tokenInvalid, organizationInboxConnectionType, expired) {
        if (this.error) {
            return this.pageState.error;
        }
        else if (this.tokenResent) {
            return this.pageState.tokenResent;
        }
        else if (tokenInvalid) {
            return this.pageState.tokenInvalid;
        }
        else if (expired) {
            return this.pageState.tokenExpired;
        }
        else if (organizationInboxConnectionType === 'IMAP') {
            return this.pageState.connectIMAP;
        }
        else if (organizationInboxConnectionType === 'Office 365') {
            return this.pageState.connectOffice;
        }
        else if (organizationInboxConnectionType === '') {
            return this.pageState.connectIndividual;
        }
    }
    connectOfficeEmailInbox(e) {
        const queryParams = this.$location.search();
        setLoadingBtn(e);
        return this.$http
            .post('/connect-microsoft-inbox', {
            params: { inbox_token: queryParams.inbox_token },
        })
            .then((resp) => {
            window.open(resp.data, '_self');
            resetLoadingBtns();
        }, (error) => {
            console.error(error.data);
            this.error = true;
            resetLoadingBtns();
        });
    }
    redirectToInboxConnectionInSettings() {
        window.open('/settings/mailbox-connection', '_self');
    }
    resendInboxToken(e) {
        const queryParams = this.$location.search();
        setLoadingBtn(e);
        return this.$http.post(`/inbox-token/${queryParams.inbox_token}/resend`, {}).then(() => {
            this.tokenResent = true;
            resetLoadingBtns();
        }, (error) => {
            console.error(error.data);
            this.error = true;
            resetLoadingBtns();
        });
    }
};
ConnectEmailInboxController = __decorate([
    Component({
        selector: 'app-email-inbox-connection-controller',
        // no associated template, is embedded static HTML-page in the server assets
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof ng !== "undefined" && ng.IHttpService) === "function" ? _a : Object, typeof (_b = typeof ng !== "undefined" && ng.ILocationService) === "function" ? _b : Object])
], ConnectEmailInboxController);
export { ConnectEmailInboxController };
